import React, { lazy, Suspense, Component } from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import Layout from "./hoc/Layout/Layout";
import Logout from "./containers/Auth/Logout/Logout";
import Aux1 from "./hoc/Aux1/Aux1";
import * as actions from "./store/actions/index";
import CacheBuster from "./CacheBuster";
import "./components/UI/Spinner/Spinner.css";
import "react-multi-carousel/lib/styles.css";
import ReactGA from "react-ga4";

const Landing = lazy(() => import("./components/Landing/Landing"));
const Home = lazy(() => import("./components/Home/Home"));
const HR = lazy(() => import("./components/HR/HR2"));
const MauzeCategory = lazy(() =>
  import("./components/MauzeCategory/MauzeCategory")
);
const Grid = lazy(() => import("./components/Grid/Grid"));
const Profile = lazy(() => import("./components/Profile/Profile"));
const Attendance = lazy(() => import("./components/Attendance/Attendance"));
// const test = lazy(() => import('./components/test/test'));
const Auth = lazy(() => import("./containers/Auth/Auth"));
const Launch = lazy(() => import("./components/Launch/Launch"));
const Login = lazy(() => import("./components/Launch/Login"));
// const Login = lazy(() => import("./containers/Auth/Auth"));
const Miqaat = lazy(() => import("./components/Miqaat/Miqaat"));
const Feedback = lazy(() => import("./components/Feedback/Feedback"));
const MumineenFeedback = lazy(() =>
  import("./components/MumineenFeedback/MumineenFeedback")
);
const AdminRegistration = lazy(() =>
  import("./components/AdminRegistration/AdminRegistration")
);
const MiqaatReport = lazy(() =>
  import("./components/MiqaatReport/MiqaatReport")
);
const MiqaatReportList = lazy(() =>
  import("./components/MiqaatReportList/MiqaatReportList")
);
const DailyReport = lazy(() => import("./components/DailyReport/DailyReport"));
const Barnamaj = lazy(() => import("./components/Barnamaj/Barnamaj"));
const PrivateJaman = lazy(() =>
  import("./components/PrivateJaman/PrivateJaman")
);
const Registration = lazy(() =>
  import("./components/Registration/Registration")
);
const Coordinator = lazy(() => import("./components/Coordinator/Coordinator"));

const TRACKING_ID = "G-JD6MHQWCGF";
ReactGA.initialize(TRACKING_ID);

const windowUrl = window.location.hash;
let paramString = windowUrl.split("?")[1];

if (paramString != undefined) {
  var queryParams = paramString.split("&").reduce(function (q, query) {
    var chunks = query.split("=");
    var key = chunks[0];
    if (key === "DT") {
      var value = decodeURIComponent(chunks[1]);
      value = isNaN(Number(value)) ? value : Number(value);
      if (value !== undefined) localStorage.setItem("itstoken", value);
    }

    return value;
  }, {});
}

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    if (a === b) continue;
    return a > b || isNaN(b);
  }
  return false;
};

class App extends Component {
  componentDidMount() {
    // document.addEventListener('contextmenu', event => event.preventDefault());
    if (localStorage.itstoken !== "" && localStorage.itstoken !== undefined) {
      this.props.onOneLoginSignup();
    }
    this.props.onTryAutoSignup();
  }

  render() {
    let routes = (
      <Suspense
        fallback={
          <div className="loader h-100">
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="spinner-border" role="status">
                {/* <span className="sr-only">Loading...</span> */}
              </div>
            </div>
          </div>
        }
      >
        <Switch>
          {/* <Route path="/" component={Auth} /> */}
          {/* <Route path="/" exact component={Landing} /> */}
          {/* <Route path="/home" exact component={Home} /> */}
          {/* <Route path="/auth" component={Auth} /> */}
          {/* <Route path="/home" exact component={Home} /> */}
          {/* <Route path="/hr" exact component={HR} />
          <Route path="/Grid" exact component={Grid} />
          <Route path="/profile" exact component={Profile} />
          <Route path="/Attendance" exact component={Attendance} />
          <Route path="/test" exact component={test} /> */}
          {/* <Route path="/auth" component={Auth} /> */}
          <Route path="/" exact component={Landing} />
          <Route path="/landing" exact component={Landing} />
          {/* <Route path="/home" component={Launch} /> */}
          <Route path="/login" exact component={Login} />
          {/* <Redirect to="/" /> */}
        </Switch>
      </Suspense>
    );

    // if (
    //   this.props.isAuthenticated &&
    //   localStorage.itstoken !== "" &&
    //   localStorage.itstoken !== undefined
    // ) {
    //   localStorage.removeItem("itstoken");
    //   debugger;
    //   routes = (
    //     <Suspense
    //       fallback={
    //         <div className="loader h-100">
    //           <div className="d-flex justify-content-center align-items-center h-100">
    //             <div className="spinner-border" role="status">
    //               <span className="sr-only"></span>
    //             </div>
    //           </div>
    //         </div>
    //       }
    //     >
    //       <Switch>
    //         <Route path="/" exact component={Launch} />
    //         <Redirect to="/" />

    //         <Route path="/logout" component={Logout} />

    //         <Route
    //           path="**"
    //           render={() => (
    //             <article>
    //               <h1 className="text-danger">No Route Configured!</h1>
    //               <h4 className="text-danger">
    //                 Please check your Route Configuration
    //               </h4>
    //             </article>
    //           )}
    //         />
    //       </Switch>
    //     </Suspense>
    //   );
    // }

    if (this.props.isAuthenticated) {
      localStorage.removeItem("itstoken");
      routes = (
        <Suspense
          fallback={
            <div className="loader h-100">
              <div className="d-flex justify-content-center align-items-center h-100">
                <div className="spinner-border" role="status">
                  {/* <span className="sr-only">Loading...</span> */}
                </div>
              </div>
            </div>
          }
        >
          <Switch>
            {/* <Route path="/" component={Launch} /> */}
            {/* <Route path="/auth" component={Auth} /> */}
            {/* <Route path="/" exact component={Home} /> */}
            <Route path="/" exact component={Launch} />
            <Route path="/logout" component={Logout} />
            <Route path="/mumineenhome" exact component={Home} />
            <Route path="/landing" exact component={Landing} />
            <Route path="/hr" exact component={HR} />
            <Route path="/Grid" exact component={Grid} />
            <Route path="/profile" exact component={Profile} />
            <Route path="/attendance" exact component={Attendance} />
            <Route path="/miqaat" exact component={Miqaat} />
            <Route path="/feedback" exact component={Feedback} />
            <Route path="/privatejaman" exact component={PrivateJaman} />
            <Route path="/registration" exact component={Registration} />
            <Route path="/coordinator" exact component={Coordinator} />
            <Route path="/mfeedback" exact component={MumineenFeedback} />
            <Route
              path="/adminregistration"
              exact
              component={AdminRegistration}
            />
            <Route path="/miqaatreport" exact component={MiqaatReport} />
            <Route
              path="/miqaatreportlist"
              exact
              component={MiqaatReportList}
            />
            <Route path="/dailyreport" exact component={DailyReport} />
             <Route path="/barnamaj" exact component={Barnamaj} />
            <Route path="/home" component={Launch} />
            <Route path="/mauzecategory" component={MauzeCategory} />
            <Route
              path="**"
              render={() => (
                <article>
                  <h1 className="text-danger">No Route Configured!</h1>
                  <h4 className="text-danger">
                    Please check your Route Configuration
                  </h4>
                </article>
              )}
            />
          </Switch>
        </Suspense>
      );
    }

    return (
      <Aux1>
        <CacheBuster>
          {() => {
            fetch(`/meta.json?${new Date().getTime()}`, { cache: "no-cache" })
              .then((response) => response.json())
              .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;
                global.metaVersion = latestVersion;

                if (latestVersion !== currentVersion) {
                  const shouldForceRefresh = semverGreaterThan(
                    latestVersion,
                    currentVersion
                  );
                  if (shouldForceRefresh) {
                    console.log(
                      `We have a new version - ${latestVersion}. Should force refresh`
                    );
                    console.log("Clearing cache and hard reloading...");

                    if (window.caches !== undefined) {
                      caches.keys().then(async function (names) {
                        await Promise.all(
                          names.map((name) => caches.delete(name))
                        );
                      });
                    }
                    // delete browser cache and hard reload
                    localStorage.removeItem("token");
                    localStorage.removeItem("expirationDate");
                    localStorage.removeItem("userId");
                    localStorage.removeItem("role");
                    localStorage.removeItem("role2");
                    localStorage.removeItem("username");
                    localStorage.removeItem("link");
                    localStorage.removeItem("photo");
                    localStorage.removeItem("temptoken");
                    localStorage.removeItem("tempuser");
                    localStorage.removeItem("locations");
                    localStorage.removeItem("itstoken");
                    localStorage.removeItem("showedit");
                    // window.location.reload(true);
                    if ("caches" in window) {
                      caches.keys().then((names) => {
                        names.forEach((name) => {
                          caches.delete(name);
                        });
                      });
                    }
                    window.location.reload(true);
                  } else {
                    console.log(
                      `You already have the latest version - ${latestVersion}. No cache refresh needed.`
                    );
                  }
                }
              });

            return <Layout>{routes}</Layout>;
          }}
        </CacheBuster>
      </Aux1>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    onOneLoginSignup: () => dispatch(actions.authCheckOneLogin()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
